import React from "react";
import {observer} from "mobx-react-lite";
import {useCsContext} from "../../state/CsInstance";
import BaseModal from "./BaseModal";

/**
 * Overlay that appears when the project is loading/compiling
 * Appears above the editor only
 */
function ProjectLoadingOverlay() {
	const {compileStore} = useCsContext();

	return (
		<>
			<BaseModal
				id="project-loading-overlay"
				isOpen={compileStore.isCompiling}
				toggle={() => {}}
				pinToTop={true}
				overlayOnly={true}
			></BaseModal>
		</>
	);
}

export default observer(ProjectLoadingOverlay);
